const MISSING_MOCK_MESSAGE = 'No more mocked responses for the query';

export function errorMessage(error: unknown): string {
  const {message} = (error ?? {}) as {message?: unknown};
  return typeof message === 'string' ? message : String(error);
}

function hasMissingMockMessage(error: unknown): boolean {
  return errorMessage(error).includes(MISSING_MOCK_MESSAGE);
}

export function isMissingMockError(error: unknown): boolean {
  if (!global.__NODE_TESTING__ || error == null || typeof error !== 'object') {
    return false;
  }
  const {networkError} = error as {networkError?: unknown};
  return hasMissingMockMessage(error) || hasMissingMockMessage(networkError);
}

const ERROR_TEST_IDENTITY_KEY = Symbol('benchlingTestIdentity');

export interface TestIdentity {
  readonly test: Mocha.Test | undefined;
  readonly epoch: number;
}

export function stampTestIdentity(error: unknown, identity: TestIdentity): void {
  if (error != null && typeof error === 'object') {
    (error as Record<symbol, TestIdentity>)[ERROR_TEST_IDENTITY_KEY] = identity;
  }
}

export function readTestIdentity(error: unknown): TestIdentity | undefined {
  if (error == null || typeof error !== 'object') {
    return undefined;
  }
  const own = (error as Record<symbol, TestIdentity | undefined>)[ERROR_TEST_IDENTITY_KEY];
  if (own != null) {
    return own;
  }
  const {networkError} = error as {networkError?: unknown};
  if (networkError != null && typeof networkError === 'object') {
    return (networkError as Record<symbol, TestIdentity | undefined>)[ERROR_TEST_IDENTITY_KEY];
  }
  return undefined;
}

export function shouldLogMissingMockError(): boolean {
  return (
    Boolean(global.__NODE_TESTING__) &&
    ['true', '1'].includes((process.env.ENABLE_MISSING_GQL_MOCK_LOGS || '').toLowerCase())
  );
}
